

























































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Getter } from "vuex-class";
import { AppGetterTypes } from "../store";
import { IPromotionModel } from "../models";

@Component
export default class PromotionFooter extends Vue {
    @Getter(AppGetterTypes.promotion)
    promotion!: IPromotionModel;

    @Getter(AppGetterTypes.version)
    version!: string;

    // eslint-disable-next-line no-undef
    assetBaseUrl: string = process.env.VUE_APP_CDN_URL + "/assets";
    miniprofiler: string | null =
        // eslint-disable-next-line no-undef
        process.env.NODE_ENV !== "production"
            ? "/mini-profiler-resources/results-index"
            : null;

    bringToTop(): void {
        // bring user to top of the page
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }
}
